import { Box, Container } from "@mui/material";
import { ReactTitle } from "react-meta-tags";

import AccountRecoveryForm from "components/auth/account-recovery";
import { HeroText } from "components/shared/Typography";

const ForgotPassword = () => {
  return (
    <Box width={1}>
      <ReactTitle title="Assay Marketplace Password Assistance" />
      <Container>
        <Box px={{ xs: 0, sm: 3 }}>
          <Box py={{ xs: 3, md: 4, lg: 5 }}>
            <HeroText letterSpacing={0.25}>
              Welcome to Assay Marketplace
            </HeroText>
          </Box>
          <AccountRecoveryForm />
        </Box>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
